import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { dataLockerLandingPageSelectedTabAtom } from '@/atoms/dataLocker/landingPage';
import { userNavOverridesAtom } from '@/atoms/queries/user';
import { DATA_LOCKER_LANDING_PAGE_TAB } from '@/consts/searchKeys';
import { DataLockerSelectedTab } from '@/types/tabs';

export const useExploreLandingPageTabs = () => {
  const { t } = useTranslation('navigation', { keyPrefix: 'crossPlatform.secondary' });
  const isClassicPlayerScoutXp = useAtomValue(userNavOverridesAtom).playerScout;
  const selectedTab = useAtomValue(dataLockerLandingPageSelectedTabAtom);
  const navigate = useNavigate();

  const tabs = [
    ...(isClassicPlayerScoutXp
      ? []
      : [
          {
            label: t('playerScout'),
            value: DataLockerSelectedTab.PLAYER,
          },
        ]),
    {
      label: t('teams'),
      value: DataLockerSelectedTab.TEAM,
    },
    {
      label: t('events'),
      value: DataLockerSelectedTab.EVENTS,
    },
  ];

  const isExistingTab = tabs.map(({ value }) => value).includes(selectedTab);

  useEffect(() => {
    // Id the user tries to access a tab that doesn't exist - send them to the default (team) tab instead
    if (!isExistingTab) {
      navigate(`?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.TEAM}`, { replace: true });
    }
  }, [isExistingTab]);

  return tabs;
};
